import Vue from 'vue';

import './global.css'

Vue.mixin({
    methods: {
        g_translate: function(idTexts, id) {
            // console.log('@translate..');
            if(!idTexts) {
                return '';
            }
            for(let it of idTexts) {
                if(it.id === id) {
                    return it.text;
                }
            }
            return '';
        },
        g_parseDate: function (date) {
            if(!date) {
                return null;
            }
            var type = typeof date;
            if(type === 'number') {
                return new Date(date);
            }
            else if(type === 'string') {
                throw new Error("todo")
            }
            else if(type === 'object') {
                if(date instanceof Date) {
                    return date;
                }
                else { //?
                    throw new Error("todo")
                }
            }
            throw new Error("date parse error")
        },
        g_formatDate: function (date, precision) {
            date = this.g_parseDate(date);
            if(!date) {
                return '';
            }
            var result = '' + date.getFullYear();
            var m = date.getMonth() + 1;
            result += '-' + (m < 10? '0': '') + m;
            var d = date.getDate();
            result += '-' + (d < 10? '0': '') + d;
            if(!precision || precision === 'day') {
                return result;
            }
            var h = date.getHours();
            var n = date.getMinutes();
            result += ' ' + (h < 10? '0': '') + h;
            result += ':' + (n < 10? '0': '') + n;
            if(precision === 'min' || precision === 'minute') {
                return result;
            }
            var s = date.getSeconds();
            result += ':' + (s < 10? '0': '') + s;
            return result;
        },
        g_postFailed: function (actionResult) {
            let msg = actionResult.msg;
            if(!msg && actionResult.errors) {
                msg = '';
                for(let key in actionResult.errors) {
                    if(msg) {
                        msg += '\n';
                    }
                    msg += actionResult.errors[key];
                }
            }
            if(actionResult.error && msg.indexOf('Network Error') !== -1) {
                console.log('post failed: ' + msg);
                return;
            }
            alert(msg);
        },
        g_post: function (url, data, cbSuccess, cbFailure) {
            if(typeof data === 'function') {
                [cbSuccess, cbFailure, data] = [data, cbSuccess, {}];
            }
            if(!cbFailure) {
                cbFailure = this.g_postFailed;
            }
            return this.$http.post(url, data).then(res => {
                if(!res) {
                    console.log('post got not response??????????????');
                    return;
                }
                let actionResult = res.data;
                if (actionResult.ok) {
                    cbSuccess(actionResult);
                }
                else {
                    cbFailure(actionResult);
                }
            }).catch(res => {
                let sErr = String(res);
                // if(sErr.indexOf('Network Error') !== -1) {
                //     sErr = '网络错误';
                // }
                // sErr = '服务异常: ' + sErr;
                cbFailure({ok: false, error: true, msg: sErr});
            });
        },
        g_confirm: function (msg, cbConfirmed) {
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cbConfirmed();
            });
        },
        g_alert: function (msg) {
            this.$alert(msg, {
                confirmButtonText: '确定',
                type: 'warning',
            });
        },
        g_showSuccess: function (msg, toast) {
            if(toast) {
                this.$message({
                    message: msg,
                    type: "success"
                });
            }
            else {
                this.$alert(msg, {
                    confirmButtonText: '确定',
                    type: 'success',
                });
            }
        },
        g_params: function (obj) {
            let params = '';
            for (let prop in obj) {
                let value = obj[prop];
                if (value !== null && value !== undefined) {
                    if(params.length !== 0) {
                        params += '&';
                    }
                    params += prop + '=' + encodeURIComponent(value);
                }
            }
            return params;
        },
    }
});



// WEBPACK FOOTER //
// ./src/addon/global/global.js